export const SET_LOAD_CART_STATE = 'SET_LOAD_CART_STATE';

export default function setLoadCart(payload) {
  return {
    type: SET_LOAD_CART_STATE,
    payload,
  };
}
